import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from '../../shared/theme'
import { NotificationProvider } from '../../shared/contexts/NotificationContext'
import { PlatformAuthProvider } from './context/PlatformAuthContext'
import PlatformAdminApp from './PlatformAdminApp'

/**
 * Raiz da app do painel de administração da plataforma. Montada pelo
 * `main.tsx` no lugar da app normal quando `isPlatformAdminHost()` é `true`
 * — nenhum dos providers da app normal (condomínio, edifícios, auth de
 * tenant) é carregado aqui.
 */
export default function PlatformAdminRoot() {
    useEffect(() => {
        document.title = 'Indlus · Administração da plataforma'
    }, [])

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <NotificationProvider>
                    <PlatformAuthProvider>
                        <PlatformAdminApp />
                    </PlatformAuthProvider>
                </NotificationProvider>
            </BrowserRouter>
        </ThemeProvider>
    )
}
